import { render, staticRenderFns } from "./TempConfig.vue?vue&type=template&id=e4d55b66&scoped=true"
import script from "./TempConfig.vue?vue&type=script&lang=js"
export * from "./TempConfig.vue?vue&type=script&lang=js"
import style0 from "./TempConfig.vue?vue&type=style&index=0&id=e4d55b66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d55b66",
  null
  
)

export default component.exports